import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';

import t from '../2.jpg';
import t1 from '../1.jpg';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import fragment from "./shader/fragment.glsl";
import vertex from "./shader/vertexParticles.glsl";
import * as dat from "dat.gui";
import gsap from "gsap";


export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer();
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0x000000, 1); 
    this.renderer.physicallyCorrectLights = true;
    // this.renderer.outputEncoding = THREE.sRGBEncoding;

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      70,
      window.innerWidth / window.innerHeight,
      0.001,
      5000
    );

    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, 1500);
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.time = 0;

    this.video = document.getElementById('video1');
    this.video2 = document.getElementById('video2');
    

   

    this.isPlaying = true;

    this.addPost()
    
    this.addObjects();
    this.resize();
    this.render();
    this.setupResize();
    this.settings();
    this.odd = 0;
    let ar = [this.video,this.video2]
    ar.forEach(v=>{
      v.addEventListener('ended',()=>{
        this.odd ++;
        // gsap.to(this.video,{
        //   duration: 0.1,
        //   autoAlpha:0
        // })
        gsap.to(this.material.uniforms.distortion,{
          duration: 2,
          value: 3,
          ease: "power2.inOut",
        })
  
        gsap.to(this.material.uniforms.progress,{
          duration: 1,
          delay: 1.5,
          value: this.odd%2,
          onComplete: ()=>{
            if(this.odd%2===0){
              this.video2.currentTime = 0;
            } else{
              this.video.currentTime = 0;
            }
          }
        })
  
        gsap.to(this.bloomPass,{
          duration: 2,
          strength: 7,
          ease: "power2.in",
        })
  
        gsap.to(this.material.uniforms.distortion,{
          duration: 2,
          value: 0,
          delay:2,
          ease: "power2.inOut",
        })
        gsap.to(this.bloomPass,{
          duration: 2,
          strength: 0,
          delay: 2,
          ease: "power2.out",
          onComplete:()=>{
            if(this.odd%2!==0){
              this.video2.currentTime = 0;
              this.video2.play()
            } else{
              this.video.currentTime = 0;
              this.video.play()
            }
            // this.video.currentTime = 0;
            // gsap.to(this.video,{
            //   duration: 0.1,
            //   autoAlpha:1,
            //   onComplete: ()=>{
                
            //     // this.video2.play();
            //     // this.material.uniforms.progress.value = 0;
            //   }
            // })
          }
        })
      });
    })
    
    


  }

  addPost(){
    this.renderScene = new RenderPass( this.scene, this.camera );

    this.bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
    this.bloomPass.threshold = this.settings.bloomThreshold;
    this.bloomPass.strength = this.settings.bloomStrength;
    this.bloomPass.radius = this.settings.bloomRadius;

    this.composer = new EffectComposer( this.renderer );
    this.composer.addPass( this.renderScene );
    this.composer.addPass( this.bloomPass );
  }

  settings() {
    let that = this;
    this.settings = {
      distortion: 0,
      bloomStrength: 0,
    };
    this.gui = new dat.GUI();
    this.gui.add(this.settings, "distortion", 0, 3, 0.01);
    this.gui.add(this.settings, "bloomStrength", 0, 10, 0.01);
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    this.composer.setSize( this.width, this.height );
    



    this.camera.updateProjectionMatrix();


  }

  addObjects() {
    let that = this;
    const video = document.getElementById( 'video1' );
    const video2 = document.getElementById( 'video2' );
    const texture = new THREE.VideoTexture( video );
    const texture1 = new THREE.VideoTexture( video2 );
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable"
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { type: "f", value: 0 },
        progress: { type: "f", value: 0 },
        distortion: { type: "f", value: 0 },
        t: { type: "t", value: texture },
        // t: { type: "t", value: new THREE.TextureLoader().load(t) },
        // t1: { type: "t", value: new THREE.TextureLoader().load(t1) },
        t1: { type: "t", value: texture1 },
        resolution: { type: "v4", value: new THREE.Vector4() },
        uvRate1: {
          value: new THREE.Vector2(1, 1)
        }
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment
    });

    this.geometry = new THREE.PlaneBufferGeometry(480*1.745, 820*1.745, 480, 820);


    this.plane = new THREE.Points(this.geometry, this.material);
    this.scene.add(this.plane);
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if(!this.isPlaying){
      this.render()
      this.isPlaying = true;
    }
  }

  render() {
    if (!this.isPlaying) return;
    this.time += 0.05;
    this.material.uniforms.time.value = this.time;
    if(this.material) console.log(this.material.uniforms.progress.value);
    // this.material.uniforms.distortion.value = this.settings.distortion;
    // this.bloomPass.strength = this.settings.bloomStrength;
    requestAnimationFrame(this.render.bind(this));
    // this.renderer.render(this.scene, this.camera);
    this.composer.render();
  }
}

new Sketch({
  dom: document.getElementById("container")
});
